import type { Command } from './types';
import { useSearchStore } from '@/store/searchStore';
import { useEditorStore } from '@/store/editorStore';

export const searchCommands: Command[] = [
  {
    id: 'search.open',
    label: 'Open Search',
    category: 'search',
    execute: () => {
      useSearchStore.getState().openSearch();
      useEditorStore.getState().setMode('searching');
    },
  },
  {
    id: 'search.close',
    label: 'Close Search',
    category: 'search',
    canExecute: () => useSearchStore.getState().isOpen,
    execute: () => {
      useSearchStore.getState().closeSearch();
      useEditorStore.getState().setMode('normal');
    },
  },
];
